import { memo } from 'react';

import InboxTabNavigator from '../components/InboxTabNavigator';

function InboxScreen() {
  // const dispatch = useDispatch();
  // const navigation =
  //   useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  // const handleAcknowledgeInbox = useCallback(
  //   () => dispatch(acknowledgeInbox()),
  //   [dispatch],
  // );

  // useEffect(() => {
  //   navigation.addListener('beforeRemove', handleAcknowledgeInbox);
  //   return () => {
  //     navigation.removeListener('beforeRemove', handleAcknowledgeInbox);
  //   };
  // }, [navigation, handleAcknowledgeInbox]);

  return <InboxTabNavigator />;
}

export default memo(InboxScreen);
